import { CardMedia, Grid, Link, Typography } from '@mui/material'
import React from 'react'
import useRapport from '../../hooks/useRapport'

import { ReactComponent as DownloadIcon } from '../../media/download_icon.svg'

const Downloads = () => {
	const { rapports } = useRapport()
	return (
		<>
			{rapports && (
				<Grid
					container
					color="white"
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'center',
						m: (theme) => theme.spacing(3, 0),
					}}
				>
					{rapports.map(({ modifiedDate: date, title: label, src, download }, index) => (
						<Grid
							item
							xs={12}
							md={3}
							sx={{
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'center',
								m: (theme) => theme.spacing(4, 0),
								'& img': { width: 200 },
							}}
							key={index}
						>
							<CardMedia component="img" width="200" height="280" image={src} sx={{ mx: 'auto' }} />
							<Typography
								component="h6"
								color="text.primary"
								sx={(theme) => ({
									display: 'block',
									fontSize: 18,
									fontWeight: 700,
									m: (theme) => theme.spacing(2, 'auto'),
									cursor: 'pointer',
									'& svg': {
										position: 'relative',
										top: 2,
										right: -7,
									},

									[theme.breakpoints.down('md')]: {
										textAlign: 'center',
										px: 0,
									},
								})}
							>
								<Link
									key={index}
									href={download}
									target="_blank"
									download
									underline="none"
									color="text.primary"
								>
									<Typography
										component="span"
										dangerouslySetInnerHTML={{ __html: label }}
										sx={{ fontWeight: 'bold' }}
									/>
									<DownloadIcon />
								</Link>
							</Typography>
						</Grid>
					))}
				</Grid>
			)}
		</>
	)
}

export default Downloads
